import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "¿Para qué edades está recomendado?",
      answer: "Está diseñado principalmente para niños entre 4 y 10 años, pero sus mensajes y actividades pueden adaptarse a distintas edades."
    },
    {
      question: "¿Es solo para niños?",
      answer: "No. Es una experiencia compartida. Padres y cuidadores también aprenden y sanan durante el proceso."
    },
    {
      question: "¿Necesito conocimientos previos?",
      answer: "No. Todo está explicado de forma sencilla, cercana y práctica."
    },
    {
      question: "¿Cómo recibo el ebook?",
      answer: "Una vez realizada la compra, recibirás acceso inmediato al libro en formato digital."
    },
    {
      question: "¿Puedo usarlo varias veces?",
      answer: "Sí. Puedes volver a leerlo, repetir actividades y adaptarlo a cada etapa del niño."
    }
  ];

  return (
    <section id="faq" className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-amber-50 to-orange-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
            ❓ Preguntas frecuentes
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-800 font-medium">
            Resolvemos tus dudas sobre el ebook
          </p>
        </div>

        <div className="space-y-4 sm:space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl sm:rounded-2xl shadow-lg hover:shadow-2xl transition-all overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 sm:px-8 py-5 sm:py-6 flex items-center justify-between gap-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <span className="font-bold text-gray-900 text-base sm:text-lg md:text-xl pr-4">
                  {faq.question}
                </span>
                <div className={`w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-gradient-to-r from-orange-500 to-rose-500 rounded-full text-white flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xl sm:text-2xl"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                } overflow-hidden`}
              >
                <div className="px-6 sm:px-8 pb-5 sm:pb-6">
                  <p className="text-gray-800 leading-relaxed text-sm sm:text-base md:text-lg font-medium">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-8 sm:mt-12">
          <a
            href="#cta"
            className="inline-block px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-orange-500 to-rose-500 text-white rounded-full text-base sm:text-lg font-bold hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer hover:scale-110 active:scale-95 shadow-lg"
          >
            🎁 Obtener el ebook ahora
          </a>
        </div>
      </div>
    </section>
  );
}
